import { useState } from "react";
import { Language } from "../../../../context/LanguageContext";
import { translations } from "../../../../configs/translations";
import './MainFinish.css'
import { getTimeFormated } from "../../../../utils/getTimeFormated";

interface Props {
    place: number | string;
    mapName: string;
    hours: number;
    minutes: number;
    seconds: number;
}

export const MainFinish = ({ place, mapName, hours, minutes, seconds }: Props) => {
    const [language, setLanguage] = useState<Language>('ru');
    const t = translations[language];

    return (
        <div className="main-finish-container">

            <div className="map-container">
                <h2 className='map-title'>{mapName} <span className='gold'>{t.completed}</span></h2>
                <div className="glare-box"></div>
            </div>

            <div className="finish-title-container">
                <h1 className="finish-title">{t.finish}<span className='gold place'>{place}</span></h1>
                <div className="finish-title-bg"></div>
            </div>

            <div className="time-container">
                <h2 className='time-title'>
                    {getTimeFormated(hours, minutes, seconds)}
                </h2>
                <div className="glare-box-time"></div>
            </div>
            <img className="blue-ray" src="../../effects/blue-ray.png" alt="blue-ray" />

        </div>
    );
}